"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYC = _interopRequireDefault(require("../KYC"));
var _KYC_AcuantGoLevelsContainer = _interopRequireDefault(require("./KYC_AcuantGoLevelsContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYC_IMComponent = function KYC_IMComponent() {
  return /*#__PURE__*/_react["default"].createElement(_KYC["default"], {
    LevelsComponent: _KYC_AcuantGoLevelsContainer["default"]
  });
};
var _default = exports["default"] = KYC_IMComponent;